import classNames from "classnames";
import React from "react";
import styles from "./plugin.module.scss";
import { ITitlePlugin } from "../../model/plugin";
import { Title } from "./plugin";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
interface AdVideoProps {
  title: ITitlePlugin[];
  link?: string;
}

export default function AdVideo(props: AdVideoProps) {
  const { title, link } = props;
  const id = link.split("/").reverse()[0];

  return (
    <div className={classNames(styles["ebook-slide"], styles["modules-video"])}>
      <Title data={title} />
      <div className={styles["content-video"]}>
        <LiteYouTubeEmbed
          id={id}
          title="YouTube video player"
          announce="Watch"
          aspectHeight={8.44}
          poster="maxresdefault"
          noCookie={true}
        ></LiteYouTubeEmbed>
      </div>
    </div>
  );
}
